import { PropsWithChildren } from 'react';

export default function Column(props: PropsWithChildren) {
  return (
    <div className="contents lg:block lg:space-y-4">
      {props.children}
    </div>
  );
}
